import Swan from "@swan-admin/swan-ai-measurements";
import { REACT_APP_ACCESS_KEY } from "./constant";

const swan = new Swan(REACT_APP_ACCESS_KEY,true);

export default swan;